module.exports = __webpack_public_path__ + "public/img/data_empty.19f0cf2f.png";